import posthog from 'posthog-js';

const { REACT_APP_POSTHOG_API_KEY, REACT_APP_POSTHOG_API_HOST } = process.env;

posthog.init(REACT_APP_POSTHOG_API_KEY, {
  api_host: REACT_APP_POSTHOG_API_HOST
});
